import { motion } from "framer-motion";
import { Mail, Instagram } from "lucide-react";
import ContactForm from "../components/ContactForm";

export default function Contacto() {
  return (
    <main data-testid="contacto-page" style={{ fontFamily: "Manrope, sans-serif" }}>
      <section className="pt-32 pb-16 px-5 lg:px-8" style={{ background: "#F8FAFC" }}>
        <div className="max-w-2xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <div className="section-label mb-5">Contacto</div>
            <h1 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F", lineHeight: 1.2 }} className="text-4xl md:text-5xl font-bold mb-5">
              Estamos aquí<br /><em style={{ color: "#1B5F7E" }}>para escucharte.</em>
            </h1>
            <p className="text-slate-500 leading-relaxed">
              Si tienes dudas, quieres más información o simplemente quieres contarnos algo, escríbenos. Respondemos en menos de 24 horas.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 pb-32 px-5 lg:px-8" style={{ background: "#FFFFFF" }}>
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            <div className="lg:col-span-2">
              <h3 style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F" }} className="text-2xl font-semibold mb-8">
                Formas de contacto
              </h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "#EBF5FB" }}>
                    <Mail size={18} style={{ color: "#1B5F7E" }} />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-700 mb-1">Email</div>
                    <a href="mailto:info@dacpac.es" className="text-[#1B5F7E] text-sm hover:underline">info@dacpac.es</a>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "#EBF5FB" }}>
                    <Instagram size={18} style={{ color: "#1B5F7E" }} />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-700 mb-1">Instagram</div>
                    <a href="https://www.instagram.com/dacpac.campamento" target="_blank" rel="noopener noreferrer" className="text-[#1B5F7E] text-sm hover:underline">@dacpac.campamento</a>
                  </div>
                </div>
              </div>
              <div className="mt-10 p-6 rounded-2xl" style={{ background: "#EBF5FB" }}>
                <p style={{ fontFamily: "Playfair Display, serif", color: "#0D3A4F", fontStyle: "italic" }} className="text-base leading-relaxed">
                  "Respondemos todas las consultas personalmente. No hay formularios automáticos ni respuestas genéricas."
                </p>
                <p className="text-xs text-slate-500 mt-4">Equipo DAC-PAC</p>
              </div>
            </div>

            <div className="lg:col-span-3">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
